import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  bankingformbg: {
    backgroundColor: "white"
  },
  brandingcontainer: {
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "24px 15px",
    [theme.breakpoints.down("lg")]: {
      height: "100%"
    }
  },
  bankingheader: {
    "& h4": {
      marginBlock: "0px",
      textAlign: "left",
      marginBottom: "4px",
      fontSize: "16px",
      fontWeight: 500
    },
    "& h6": {
      marginBlock: "0px",
      textAlign: "left",
      fontWeight: 400,
      fontSize: "14px",
      color: "#667185",
      marginBottom: "32px"
    }
  },
  imagecont: {
    width: "120px",
    height: "120px",
    position: "relative"
  },
  pickimage: {
    width: "20px",
    position: "absolute",
    right: "0px",
    bottom: "11px",
    background: "white",
    borderRadius: "50%"
  },
  previewImage: {
    // marginTop: "10px",
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    border: "2px solid #FFFFFF",
    objectFit: "cover"
  },
  title: {
    color: "#101928",
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: "-0.5px",
    textAlign: "left",
    marginTop: "0px",
    marginBottom: "4px"
  },
  subtitle: {
    color: "#667185",
    letterSpacing: "-0.4px",
    textAlign: "left",
    fontWeight: 400,
    fontSize: "14px",
    marginTop: "0px"
  },
  logouploadcontainer: {
    width: "180px",
    height: "80px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    backgroundColor: tinycolor(theme.palette.primary.main)
      .lighten(45)
      .toHexString(),
    fontSize: 32,
    "@media (max-width: 426px)": {
      width: "100%"
    }
  },
  logoupload: {
    width: "90%",
    height: "50%",
    margin: "auto"
  },
  imagecontainer: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tinycolor(theme.palette.primary.main)
      .lighten(45)
      .toHexString(),
    fontSize: 32,
    fontWeight: "bold"
  },
  // profileform: {
  //   // width: "70%!important",
  //   [theme.breakpoints.up("lg")]: {
  //     width: "70%!important"
  //   }
  // },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
    // [theme.breakpoints.down("sm")]: {
    //   flexDirection: "column",
    //   alignItems: "flex-start"
    // }
  },
  brandflex: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    marginTop: "20px"
  },
  brandesc: {
    width: 200,
    [theme.breakpoints.down("sm")]: {
      width: "100%!important"
    }
  },
  filepicker: {
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
    position: "absolute",
    left: 0,
    top: 0
  },
  editpencil: {
    fontSize: 20
  },
  selectimage: {
    position: "relative",
    width: 200,
    height: 45,
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 32,
    fontWeight: 600,
    fontSize: 12,
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 5
  },
  palettecontainer: {
    fontFamily: "Trip Sans"
  },
  palettewrapper: {
    width: 55,
    height: 55,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    borderRadius: "50%"
  },
  blueselected: {
    border: "1px solid #0065FF"
  },
  blackselected: {
    border: "1px solid #000000"
  },
  pinkselected: {
    border: "1px solid #B00074"
  },
  greenselected: {
    border: "1px solid #099137"
  },
  yellowselected: {
    border: "1px solid #AD6F07"
  },
  colorpalette: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: "2px solid #E4E7EC",
    "&:hover, &:focus": {
      cursor: "pointer"
    }
  },
  paletteblue: {
    backgroundColor: "#0065FF"
  },
  paletteblack: {
    backgroundColor: "#000000"
  },
  palettepink: {
    backgroundColor: "#B00074"
  },
  palettegreen: {
    backgroundColor: "#099137"
  },
  paletteyellow: {
    backgroundColor: "#AD6F07"
  },
  btnspace: {
    marginTop: 15
  },
  downloadbutton: {
    marginTop: 20,
    textAlign: "center"
  },
  profilecontainer: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    height: 258,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 22
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 15
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  selectcontainer: {
    position: "absolute",
    zIndex: 1000,
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "25px",
    height: "25px",
    bottom: 0,
    right: 0,
    color: "white",
    borderRadius: "50%"
  },
  camera: {
    color: theme.palette.primary.main,
    width: "14px!important"
  },
  profilepicker: {
    opacity: 0,
    width: 25,
    height: 25,
    zIndex: 1000,
    cursor: "pointer",
    position: "absolute"
  },
  imageviewer: {
    width: "140px",
    height: "140px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "relative"
  },
  removefile: {
    color: "#E93831",
    fontWeight: 400,
    fontSize: 16,
    display: "flex",
    alignItems: "center",
    gap: 6
  },
  label: {
    fontWeight: "500",
    fontSize: "16px",
    "& p": {
      textAlign: "left",
      marginBlock: "0px"
    }
  },
  previewGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    marginBlock: "1.3rem"
  },
  previewItem: {
    position: "relative",
    width: "100px",
    height: "100px"
  },
  previewAnImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px"
  },
  removeBtn: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    background: "#ff4d4d",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.75rem"
  },
  // SIGNATURE
  signatureWrap: {
    width: "100%"
  },
  signatureLabel: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8,
    textAlign: "left",
    color: "#1f2937"
  },
  signatureCard: {
    position: "relative",
    width: "100%",
    minHeight: 140,
    background:
      "repeating-linear-gradient(0deg, #f8fafc, #f8fafc 12px, #f1f5f9 12px, #f1f5f9 24px)",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)"
  },
  signatureImg: {
    maxWidth: "90%",
    maxHeight: 110,
    objectFit: "contain",
    filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.06))"
  },
  signatureEmpty: {
    fontSize: 13,
    color: "#64748b",
    background: "#fff",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px dashed #cbd5e1"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center"
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    height: "100%"
  },
  addIcon: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    color: theme.palette.primary.main,
    fontSize: "18px",
    justifyContent: "center",
    fontWeight: "bold",
    pointer: "cursor"
  },
  account_details: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: 0
  },
  accord_body: {
    borderRadius: "16px",
    padding: "15px 20px",
    border: "1px solid #E4E7EC"
  },
  accord_body_primary: {
    border: `2px solid ${theme.palette.primary.main}`
  },
  span: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#98A2B3"
  },
  Icon: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    color: theme.palette.primary.main,
    fontSize: "16px",
    justifyContent: "flex-start",
    pointer: "cursor"
  },
  bank_currency: {
    margin: 0,
    padding: "2px 8px",
    borderRadius: "50%",
    background: theme.palette.primary.main,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px"
  },
  textandimg: {
    position: "relative",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    height: "150px",
    "& textarea": {
      width: "100%",
      height: "150px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingBlock: "10px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "black"
    }
  },
  notfound: {
    maxWidth: "300px",
    paddingBottom: "50px",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh"
  }
}));
